<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" :color="color" :mini-variant.sync="mini" permanent dark app>
      <v-list dense class="py-0">
        <v-list-item class="px-2">
          <!-- Foto do utilizador 128x128 -->
          <v-list-item-avatar>
            <img src="https://randomuser.me/api/portraits/men/81.jpg" />
          </v-list-item-avatar>
          <!-- Nome da empresa e nome do utilizador -->
          <v-list-item-content>
            <v-list-item-title>Master Clinic</v-list-item-title>
            <v-list-item-subtitle>Eugénia Marques</v-list-item-subtitle>
          </v-list-item-content>
          <!-- Botao de esconder menu -->
          <v-btn icon @click.stop="mini = !mini">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item v-for="item in items" :key="item.title" link router :to="item.route">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app> </v-app-bar>

    <Dashboard />

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import Dashboard from "./components/Dashboard";

export default {
  name: "App",

  components: { Dashboard },

  data() {
    return {
      drawer: true,
      items: [
        { title: "Agenda", icon: "mdi-calendar-check", route: "/agenda" },
        { title: "Clientes", icon: "mdi-account-group", route: "/clientes" },
        { title: "Tratamentos", icon: "mdi-bed", route: "/tratamentos" },
        { title: "Galeria", icon: "mdi-image", route: "/fotos" }
      ],
      color: "primary",
      colors: ["primary", "blue", "success", "red", "teal"],
      miniVariant: false,
      expandOnHover: false,
      background: false,
      mini: false
    };
  }
};
</script>
